/**
 * Formats a number as USD currency.
 * For values < 1: shows 2-4 decimal places (removes trailing zeros beyond 2nd decimal)
 * For values >= 1: always shows exactly 2 decimal places
 */
export function formatCurrency(value) {
    let formatted;
    if (value < 1) {
        // Start with 4 decimal places
        formatted = value.toFixed(4);
        // Remove trailing zeros, but keep at least 2 decimals
        while (formatted.endsWith('0') && formatted.split('.')[1].length > 2) {
            formatted = formatted.slice(0, -1);
        }
    }
    else {
        // Always 2 decimals for values >= 1
        formatted = value.toFixed(2);
    }
    if (formatted.startsWith('-')) {
        // Handle negative values correctly
        return `-$${formatted.slice(1)}`;
    }
    return `$${formatted}`;
}
/**
 * Formats a quantity with thousand separators.
 * Returns empty string if null.
 */
export function formatQuantity(qty) {
    if (qty === null)
        return '';
    return qty.toLocaleString();
}
